import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { NavigationService } from 'src/app/shared/router.service';
import { initNavbarParams } from 'src/app/shared/utils/helpers';

@Component({
  selector: 'app-main-settings',
  templateUrl: './main-settings.component.html',
  styleUrls: ['./main-settings.component.scss'],
})
export class MainSettingsComponent implements OnInit {
  constructor(
    private navigationService: NavigationService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  onActivate(e: any): void {
    const currentActivatedRoute: ActivatedRoute | null =
      this.getCurrentActivatedRoute();
    this.navigationService.setCurrentRoute(currentActivatedRoute);
    initNavbarParams(this.store, currentActivatedRoute);
  }

  onDeactivate(e: any): void {
    initNavbarParams(this.store, null, true);
  }

  getCurrentActivatedRoute(): ActivatedRoute | null {
    let route: ActivatedRoute | null = this.activatedRoute.firstChild;
    while (route?.firstChild) {
      route = route?.firstChild;
    }
    return route;
  }
}
